var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _circle2, _circle3, _circle4, _path11, _circle5, _circle6, _circle7, _path12, _circle8, _circle9, _path13, _path14, _path15, _circle10, _circle11, _circle12, _path16, _path17, _path18, _path19, _circle13, _circle14, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialmedia01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.62 26.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#052d4b;}.cls-2{fill:url(#Degradado_sin_nombre_12);}.cls-3{fill:#05324a;}.cls-4{fill:#101429;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#9ed9f8;}.cls-7{opacity:0.44;fill:url(#linear-gradient-2);}.cls-8{fill:url(#Degradado_sin_nombre_11);}.cls-9{fill:url(#Degradado_sin_nombre_10);}.cls-10,.cls-16,.cls-20{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-10{stroke-width:0.32px;}.cls-11,.cls-17{fill:#fff;}.cls-12{fill:url(#Degradado_sin_nombre_9);}.cls-13{fill:url(#Degradado_sin_nombre_8);}.cls-14{fill:url(#Degradado_sin_nombre_7);}.cls-15{fill:url(#Degradado_sin_nombre_6);}.cls-16{stroke-width:0.28px;}.cls-17{fill-rule:evenodd;}.cls-18{fill:url(#Degradado_sin_nombre_5);}.cls-19{fill:url(#Degradado_sin_nombre_4);}.cls-20{stroke-width:0.41px;}.cls-21{fill:url(#Degradado_sin_nombre_3);}.cls-22{fill:url(#Degradado_sin_nombre_2);}.cls-23{fill:#e50054;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_12",
    x1: 5.16,
    y1: 13.08,
    x2: 18.85,
    y2: 13.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#005877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#006184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#007099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0084b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.63,
    y1: 1.09,
    x2: 5.12,
    y2: 27.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2ecfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ceeafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#c1e3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#acd7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8fc7e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#69b2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b99c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a98c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6.89,
    y1: 14.66,
    x2: 22.85,
    y2: 10.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11",
    x1: -811.25,
    y1: -352.59,
    x2: -807.57,
    y2: -357.57,
    gradientTransform: "translate(90.28 888.05) rotate(60.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07101e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#052d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021b30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: -811.51,
    y1: -352.83,
    x2: -807.82,
    y2: -357.81,
    gradientTransform: "translate(-455.25 762.1) rotate(97.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#083e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#083e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#085e9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    x1: 15.46,
    y1: 21.78,
    x2: 17.67,
    y2: 17.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#420e06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5a0a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a0a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    x1: 1219.03,
    y1: 1174.97,
    x2: 1222.72,
    y2: 1169.99,
    gradientTransform: "translate(-220.77 -1656.26) rotate(38.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a0a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e30613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7",
    x1: 1234.83,
    y1: 1285.31,
    x2: 1238.01,
    y2: 1281.01,
    gradientTransform: "translate(-1410.28 -1060.71) rotate(-9.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#032f13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#024e21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032d12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    x1: 11.19,
    y1: 12.7,
    x2: 14.75,
    y2: 11.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154925"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_5",
    x1: -4193.4,
    y1: 870.46,
    x2: -4188.66,
    y2: 864.06,
    gradientTransform: "matrix(-0.91, 0.4, 0.4, 0.91, -4167.37, 908.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#250520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#541239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e153b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 20.01,
    y1: 11.55,
    x2: 14.11,
    y2: 6.87,
    gradientTransform: "translate(1.32 -2.1) rotate(7.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdc100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bb1832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c2a86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 4.13,
    y1: 15.53,
    x2: 9.21,
    y2: 21.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00487e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#217fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00487e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: -3177.72,
    y1: 5772.21,
    x2: -3183.62,
    y2: 5767.54,
    gradientTransform: "translate(-6196.35 -2203.09) rotate(-99.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ab9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.07,26.21c0,.25-4.91.44-11,.44s-11-.19-11-.44,4.91-.44,11-.44S23.07,26,23.07,26.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.41,0h9.2a2.24,2.24,0,0,1,2.24,2.25V23.92a2.24,2.24,0,0,1-2.24,2.24H6.85c-1.24,0-1.69-1-1.69-2.24V2.25A2.25,2.25,0,0,1,7.41,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.85,25.92c-1.2,0-1.45-1.09-1.45-2V2.25a2,2,0,0,1,2-2h9.2a2,2,0,0,1,2,2V23.92a2,2,0,0,1-2,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.6,1.31h2.58c.06,0,.1.07.1.14s0,.14-.1.14H10.6c-.06,0-.1-.06-.1-.14S10.54,1.31,10.6,1.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.44.55h-.88L14.69,1.6a1.09,1.09,0,0,1-.85.41H10.2a1.09,1.09,0,0,1-.85-.41l-.86-1H7.6a1.94,1.94,0,0,0-1.93,2V23.66c0,.89.24,2,1.39,2h9.38a1.94,1.94,0,0,0,1.93-2V2.5A1.94,1.94,0,0,0,16.44.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.76,9.93c0,3.83,0,6.94,0,6.94s0-3.11,0-6.94,0-6.94,0-6.94S18.76,6.1,18.76,9.93Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M5.3,9.93c0,3.83,0,6.94,0,6.94s0-3.11,0-6.94S5.26,3,5.27,3,5.3,6.1,5.3,9.93Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.08.12c-2.17,0-3.93,0-3.93,0s1.76,0,3.93,0S16,.08,16,.1,14.24.12,12.08.12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 13.62,
    cy: 1.44,
    r: 0.16
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M16.61,0H8.77l9,25.84a2.25,2.25,0,0,0,1.08-1.92V2.25A2.24,2.24,0,0,0,16.61,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.89,26.06c-2.16,0-3.92,0-3.92,0s1.76,0,3.92,0,3.93,0,3.93,0S14.06,26.06,11.89,26.06Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 6.39,
    cy: 8.17,
    r: 3.1,
    transform: "translate(-3.9 6.91) rotate(-45)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 6.21,
    cy: 7.87,
    r: 3.1,
    transform: "translate(-2.46 12.91) rotate(-81.9)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 6.21,
    cy: 7.87,
    r: 2.83
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M5.57,9l.49.14.36-1.24.34.1.15-.4-.38-.11.07-.24c0-.1.06-.13.15-.1L7,7.2l.12-.43L6.8,6.68c-.37-.11-.58,0-.67.32L6,7.33l-.26-.08-.12.42.26.08Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 16.5,
    cy: 19.85,
    r: 3.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 16.16,
    cy: 19.76,
    r: 3.1,
    transform: "translate(-8.23 27.3) rotate(-67.91)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 16.16,
    cy: 19.76,
    r: 2.83
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M15.9,20.45a.07.07,0,0,0,0-.1l-.08-.12a.1.1,0,0,0-.1-.05.6.6,0,0,1-.34-.15.86.86,0,0,1,0-1.25.68.68,0,0,1,1-.1c.39.36.56.83.33,1.08a.28.28,0,0,1-.45,0,4.32,4.32,0,0,0-.37-.55.25.25,0,0,0-.37,0,.42.42,0,0,0,.11.58.64.64,0,0,0,.25.15s.49.72.58.84a2,2,0,0,0,.51.47s0,0,0,0a2.35,2.35,0,0,0-.22-.65l-.29-.43a.5.5,0,0,0,.47-.18,1.15,1.15,0,0,0-1.81-1.41,1.2,1.2,0,0,0,0,1.73A.69.69,0,0,0,15.9,20.45Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 12.24,
    cy: 12.47,
    r: 2.67,
    transform: "translate(-3.88 5.72) rotate(-22.81)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 11.94,
    cy: 12.41,
    r: 2.67
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M14,11.13a2.44,2.44,0,1,1-3.36-.79A2.44,2.44,0,0,1,14,11.13Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M13.26,11.76a1.35,1.35,0,0,0-2.53,1,.14.14,0,0,0,0,.06,1.32,1.32,0,0,0,.43.58l0,.76.61-.5a1.3,1.3,0,0,0,.67-.08,1.35,1.35,0,0,0,.78-1.75Zm-.84,1.58a1,1,0,0,1-.65.05l-.36.29s-.37-.75-.46-1a.42.42,0,0,1,0-.1,1.15,1.15,0,0,1,.69-1.37,1.14,1.14,0,0,1,1.44.56l0,.08A1.13,1.13,0,0,1,12.42,13.34Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M12.69,12.31h-.25s-.06,0-.07,0a.75.75,0,0,1,0,.16s0,0-.06,0a.75.75,0,0,1-.31,0,1,1,0,0,1-.25-.15.05.05,0,0,1,0-.07l0-.07v-.06a.11.11,0,0,0,0-.06l-.19-.19c0-.05-.07,0-.09,0l-.06,0a.15.15,0,0,0-.07.07.41.41,0,0,0,0,.3l.05.1a1,1,0,0,0,.2.17,1.35,1.35,0,0,0,.71.26c.36,0,.34,0,.4-.07a.38.38,0,0,0,.15-.23c0-.08,0-.14,0-.15Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 17.2,
    cy: 9.87,
    r: 3.98
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 17.38,
    cy: 9.46,
    r: 3.98,
    transform: "translate(-1.05 2.24) rotate(-7.17)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 17.38,
    cy: 9.46,
    r: 3.63
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M16.73,8l.66-.34a1.12,1.12,0,0,1,.34-.11.71.71,0,0,1,.25,0,.59.59,0,0,1,.22.12.92.92,0,0,1,.22.28l.37.65c.23.44.26.49.34.67a1,1,0,0,1,.11.33.57.57,0,0,1,0,.26.48.48,0,0,1-.12.22,1,1,0,0,1-.27.22c-.17.1-.22.13-.66.36s-.49.26-.66.35a.82.82,0,0,1-.34.1.53.53,0,0,1-.25,0,.48.48,0,0,1-.22-.12,1,1,0,0,1-.22-.27c-.1-.17-.13-.22-.37-.66s-.26-.49-.34-.67A1,1,0,0,1,15.65,9a.69.69,0,0,1,0-.25.65.65,0,0,1,.13-.23,1.24,1.24,0,0,1,.27-.22c.17-.1.22-.13.66-.36m-.16-.29c-.45.23-.5.27-.67.37a1.41,1.41,0,0,0-.36.29,1.11,1.11,0,0,0-.19.34,1,1,0,0,0,0,.39,1.37,1.37,0,0,0,.14.44c.08.18.11.23.35.68s.27.5.37.67a1.19,1.19,0,0,0,.29.35.81.81,0,0,0,.34.19,1.06,1.06,0,0,0,.39,0,1.68,1.68,0,0,0,.44-.14c.18-.09.24-.11.68-.35l.67-.37a1.67,1.67,0,0,0,.36-.29,1,1,0,0,0,.18-.35.88.88,0,0,0,0-.39,1.33,1.33,0,0,0-.14-.43,7.64,7.64,0,0,0-.35-.68c-.24-.45-.27-.5-.37-.67a1.26,1.26,0,0,0-.29-.36.94.94,0,0,0-.34-.19.87.87,0,0,0-.39,0,1.16,1.16,0,0,0-.44.14,7.64,7.64,0,0,0-.68.35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M17,8.47a1,1,0,0,0-.39,1.29A1,1,0,1,0,17,8.47m.75,1.39a.62.62,0,0,1-.84-.26.61.61,0,0,1,.25-.83.62.62,0,1,1,.59,1.09"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M18.05,7.87a.24.24,0,0,1-.09.3.23.23,0,0,1-.31-.09.23.23,0,0,1,.09-.3.23.23,0,0,1,.31.09"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M10.28,17A4,4,0,1,0,7.83,22,4,4,0,0,0,10.28,17Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 6.32,
    cy: 18.65,
    r: 3.98,
    transform: "translate(-13.3 20.33) rotate(-76.19)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 6.32,
    cy: 18.65,
    r: 3.63,
    transform: "translate(-2.25 0.92) rotate(-7.09)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M4.91,20.64a2.39,2.39,0,0,0,2.84-3.15A1.64,1.64,0,0,0,8,16.94a1.54,1.54,0,0,1-.42.28.81.81,0,0,0,.21-.56,1.69,1.69,0,0,1-.44.36A.86.86,0,0,0,6.69,17a.84.84,0,0,0-.46,1.23,2.36,2.36,0,0,1-1.91-.29.83.83,0,0,0,.59,1,.87.87,0,0,1-.39,0,.84.84,0,0,0,.9.58.93.93,0,0,1-.36.14.86.86,0,0,0,.93.31A1.71,1.71,0,0,1,4.91,20.64Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M23.58,3l-.73-1.46a.37.37,0,0,0-.5-.16l-1.46.73a.38.38,0,0,0-.17.5l.23.46-.46.54s0,.06,0,.06l.7-.06.23.46a.39.39,0,0,0,.51.17l1.46-.73A.38.38,0,0,0,23.58,3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.26,2.16a.36.36,0,0,0-.2.36.37.37,0,0,0-.41-.07.38.38,0,0,0-.17.48c.22.45.94.35.94.35s.5-.55.31-.95A.36.36,0,0,0,22.26,2.16Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M0,12.76l.37-1.59a.37.37,0,0,1,.45-.28l1.59.37a.37.37,0,0,1,.28.45l-.12.5.58.41s0,.06,0,.07l-.69.1-.12.51a.38.38,0,0,1-.45.28L.29,13.21A.38.38,0,0,1,0,12.76Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1.11,11.64a.34.34,0,0,1,.27.3.37.37,0,0,1,.38-.16A.36.36,0,0,1,2,12.2c-.11.49-.83.57-.83.57s-.61-.43-.52-.85A.35.35,0,0,1,1.11,11.64Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmedia01);
export default __webpack_public_path__ + "static/media/socialmedia-01.f77e5614fb816a637761152647bc85ea.svg";
export { ForwardRef as ReactComponent };